import { render } from "./areaTeaXlEchart.vue?vue&type=template&id=0e8385f0&scoped=true"
import script from "./areaTeaXlEchart.vue?vue&type=script&lang=js"
export * from "./areaTeaXlEchart.vue?vue&type=script&lang=js"

import "./areaTeaXlEchart.vue?vue&type=style&index=0&id=0e8385f0&scoped=true&lang=scss"

import exportComponent from "E:\\JzHyLyEdu\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0e8385f0"]])

export default __exports__